import type { AppRedirect } from 'src/shared/routes';

export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/nonprofit/claim',
		buildUrl: ({ queryString }) => `/nonprofit/claim/search${queryString}`,
		reason: 'canonical-url',
	},
];
